import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-statistics" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = {
  key: 1,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass({selected: _ctx.type === 1}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectType(1)))
      }, _toDisplayString(_ctx.$t('AdViewsStatistics.type-1')), 3),
      _createElementVNode("a", {
        class: _normalizeClass({selected: _ctx.type === 2}),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectType(2)))
      }, _toDisplayString(_ctx.$t('AdViewsStatistics.type-2')), 3),
      _createElementVNode("a", {
        class: _normalizeClass({selected: _ctx.type === 3}),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectType(3)))
      }, _toDisplayString(_ctx.$t('AdViewsStatistics.type-3')), 3),
      _createElementVNode("a", {
        class: _normalizeClass({selected: _ctx.type === 0}),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectType(0)))
      }, _toDisplayString(_ctx.$t('AdViewsStatistics.type-0')), 3)
    ]),
    (_ctx.chartData)
      ? (_openBlock(), _createBlock(_component_Line, {
          key: 0,
          class: "graph-responsive",
          "chart-options": _ctx.chartOptions,
          "chart-data": _ctx.chartData,
          "chart-id": _ctx.chartId,
          "css-classes": _ctx.cssClasses
        }, null, 8, ["chart-options", "chart-data", "chart-id", "css-classes"]))
      : _createCommentVNode("", true),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("b", null, _toDisplayString(_ctx.data.totalCount) + "x", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('AdViewsStatistics.view-count')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}